export const choices = () => {
  return [
    { id: 'website', name: 'domain.types.website' },
    { id: 'internal_alias', name: 'domain.types.internal_alias' },
    { id: 'external_alias', name: 'domain.types.external_alias' },
  ];
};
